import { SurveyV2, UserDto } from '@act/shared/data-transfer-objects';
import { Box, Typography } from '@mui/material';
import { applyMustacheTemplate } from '@act/shared/utilities';
import HtmlDisplayer from 'react-components/components/html-displayer';

interface PromptMockProps {
  prompt: SurveyV2.CreatePromptJSONDto;
  member: Partial<UserDto>;
}

const PromptMock = ({ prompt, member }: PromptMockProps) => {
  if (!prompt) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        margin: '16px 16px 16px 0',
        padding: '24px',
        background: '#fbfcfe',
        borderRadius: '8px',
        border: '1px solid #dce4e8',
      }}
    >
      <Typography variant="subheadLarge" sx={{ fontWeight: '600' }}>
        {prompt.title
          ? applyMustacheTemplate(prompt.title, {
              memberName: `${member?.firstName}`,
            })
          : ''}
      </Typography>
      <Typography variant="subheadLarge" sx={{ fontWeight: '400' }}>
        {prompt.text ? (
          <HtmlDisplayer
            innerHtml={applyMustacheTemplate(prompt.text, {
              memberName: `${member?.firstName}`,
            })}
          />
        ) : (
          ''
        )}
      </Typography>
    </Box>
  );
};

export default PromptMock;
